module.exports = __webpack_public_path__ + "img/authentication_success.c2d54674.png";